module.exports = __webpack_public_path__ + "static/img/ikona_cw6-ON.a24a6107.png";